import React from "react";
import BaselineOption from "../CommonElements/BaselineOption";
import KpiOption from "../CommonElements/KpiOption";
import QualitativeOption from "../CommonElements/QualitativeOption";
import RequireOption from "../CommonElements/RequireOption";

export function InputNumberOptionsTab({component_key, attributes, dispatch}) {
  return (
    <div>
      <RequireOption
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
      />
      <KpiOption
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
      ></KpiOption>
      <BaselineOption
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
      />
      <QualitativeOption
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
      />
    </div>
  );
}

export default InputNumberOptionsTab;
